import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  // {
  //     path: routeNames.settingBanner,
  //     component: () => import('../../pages/taskActivityManagement/settingBanner'),
  //     meta: { title: 'banner配置' }
  // },
  {
    path: routeNames.publicSetting,
    component: () => import('../../pages/taskActivityManagement/publicSetting'),
    meta: { title: '公众号管理' }
  },
  {
    path: routeNames.IntegralSetting,
    component: () => import('../../pages/taskActivityManagement/IntegralSetting'),
    meta: { title: '积分设置' }
  },
  {
    path: routeNames.taskListManagement,
    component: () => import('../../pages/taskActivityManagement/taskListManagement'),
    meta: { title: '任务列表' }
  },
  {
    path: routeNames.taskDetail,
    component: () => import('../../pages/taskActivityManagement/TaskDetail'),
    meta: { title: '任务参与详情', hideInMenu: true }
  },
  {
    path: routeNames.settingTask,
    component: () => import('../../pages/taskActivityManagement/taskListManagement/settingTask'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: routeNames.checkingDatabase,
    component: () => import('../../pages/taskActivityManagement/checkingDatabase'),
    meta: {
      title: '校验数据库列表'
    }
  },
  {
    path: routeNames.IntegralRecordDetail,
    component: () => import('../../pages/taskActivityManagement/checkingDatabase/IntegralRecordDetail'),
    meta: {
      hideInMenu: true,
      title: '记录详情'
    }
  },
  {
    path: routeNames.researchTemplate,
    component: () => import('../../pages/taskActivityManagement/researchTemplate'),
    meta: { title: '调研模板' }
  },
  {
    path: routeNames.settingTemplate,
    component: () => import('../../pages/taskActivityManagement/researchTemplate/settingTemplate'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: routeNames.researchTemplateDetail,
    component: () => import('../../pages/taskActivityManagement/researchTemplate/researchTemplateDetail'),
    meta: {
      hideInMenu: true,
      title: '调研详情'
    }
  },
  // {
  //   path: routeNames.largeTurntableManagement,
  //   component: () => import('../../pages/taskActivityManagement/largeTurntableManagement'),
  //   meta: {
  //     title: '大转盘活动'
  //   }
  // },
  // {
  //   path: routeNames.addLargeTurntable,
  //   component: () => import('../../pages/taskActivityManagement/largeTurntableManagement/addLargeTurntable'),
  //   meta: {
  //     hideInMenu: true,
  //     title: '新增大转盘'
  //   }
  // },
  // {
  //   path: routeNames.lotteryRecordManagement,
  //   component: () => import('../../pages/taskActivityManagement/lotteryRecordManagement'),
  //   meta: {
  //     title: '抽奖记录'
  //   }
  // },
  // {
  //   path: routeNames.largeTurntableRecordManagement,
  //   component: () => import('../../pages/taskActivityManagement/largeTurntableRecordManagement'),
  //   meta: {
  //     title: '大转盘记录'
  //   }
  // },
  {
    path: routeNames.blindBoxManagement,
    component: () => import('../../pages/taskActivityManagement/blindBoxManagement/index'),
    meta: {
      title: '盲盒活动管理'
    }
  },
  {
    path: routeNames.blindBoxEdit,
    component: () => import('../../pages/taskActivityManagement/blindBoxManagement/edit'),
    meta: {
      title: '新建盲盒活动',
      hideInMenu: true
    }
  },
  {
    path: routeNames.blindBoxPrizeList,
    component: () => import('../../pages/taskActivityManagement/blindBoxManagement/prizeList'),
    meta: {
      title: '盲盒中奖记录'
    }
  },
  {
    path: routeNames.blindBoxJoinList,
    component: () => import('../../pages/taskActivityManagement/blindBoxManagement/joinList'),
    meta: {
      title: '抽盲盒记录'
    }
  },
  {
    path: routeNames.trialActivitiesManagement,
    component: () => import('../../pages/taskActivityManagement/trialActivitiesManagement'),
    meta: {
      title: '试用活动'
    }
  },
  {
    path: routeNames.trialActivitiesSetting,
    component: () => import('../../pages/taskActivityManagement/trialActivitiesManagement/trialActivitiesSetting'),
    meta: {
      hideInMenu: true,
      title: '新增试用活动'
    }
  },
  {
    path: routeNames.resultDataSetting,
    component: () => import('../../pages/taskActivityManagement/trialActivitiesManagement/resultDataSetting'),
    meta: {
      title: '效果测评数据设置',
      hideInMenu: true
    }
  },
  {
    path: routeNames.trialRecordManagement,
    component: () => import('../../pages/taskActivityManagement/trialRecordManagement'),
    meta: {
      title: '试用记录'
    }
  },
  {
    path: routeNames.trialRecordDetail,
    component: () => import('../../pages/taskActivityManagement/trialRecordManagement/trialRecordDetail'),
    meta: {
      hideInMenu: true,
      title: '试用记录详情'
    }
  },
  {
    path: routeNames.liveBroadcastList,
    component: () => import('../../pages/taskActivityManagement/liveBroadcastList'),
    meta: {
      title: '直播列表'
    }
  },
  {
    path: routeNames.addLiveBroadcast,
    component: () => import('../../pages/taskActivityManagement/liveBroadcastList/addLiveBroadcast'),
    meta: {
      hideInMenu: true,
      title: '新增直播列表'
    }
  },
  {
    path: routeNames.editLiveBroadcast,
    component: () => import('../../pages/taskActivityManagement/liveBroadcastList/editLiveBroadcast'),
    meta: {
      hideInMenu: true,
      title: '编辑直播列表'
    }
  },
  {
    path: routeNames.viewLiveBroadcastDetail,
    component: () => import('../../pages/taskActivityManagement/liveBroadcastList/viewLiveBroadcastDetail'),
    meta: {
      hideInMenu: true,
      title: '编辑直播列表'
    }
  },
  {
    path: routeNames.clockApplicationReview,
    component: () => import('../../pages/taskActivityManagement/clockApplicationReview'),
    meta: {
      title: '打卡申请审核'
    }
  },
  {
    path: routeNames.clockRecord,
    component: () => import('../../pages/taskActivityManagement/clockRecord'),
    meta: {
      title: '商品打卡记录'
    }
  },
  {
    path: routeNames.clockRecordDetail,
    component: () => import('../../pages/taskActivityManagement/clockRecord/detail'),
    meta: {
      title: '商品打卡记录详情',
      hideInMenu: true
    }
  },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '调研模板' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '活动积分获取记录' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '大转盘活动' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '抽奖记录' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '试用活动' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '试用记录' }
  // },
  // {
  //     path: routeNames.roleManagement,
  //     component: () => import('../../pages/taskActivityManagement/roleManagement'),
  //     meta: { title: '直播列表' }
  // }
  {
    path: routeNames.redeemPoints,
    component: () => import('../../pages/taskActivityManagement/RedeemPoints'),
    meta: { title: '订单换积分活动' }
  }
] as TRoutes[]
